const formConfigMessageKeys: Record<string, string> = {
  JlFcis: 'formConfig.send',
  hQRttt: 'formConfig.submit',
  PyQXVE: 'formConfig.singleFieldForm',
  'tl1gW+': 'formConfig.complexInfoForm',
  jVrW7Y: 'formConfig.detailedForm',
  tsrWg5: 'formConfig.userInput',
  CU14Cg: 'formConfig.textPlaceholder',
  jLE7QB: 'formConfig.fillOutForm'
}

export function resolveFormConfigText(value: string | undefined, t: (key: string) => string): string | undefined {
  if (!value) return undefined

  const key = formConfigMessageKeys[value]

  return key ? t(key) : value
}
